import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTenant } from '../context/TenantContext';
import { useWebBookingBranding } from '../context/WebBookingBrandingContext';
import {
  applyBookingUiPreset,
  fetchAndApplyBookingUiPreset,
  resetWebChromeFromExperience,
} from '../bookingAppearance';
import { emptyWebPublicExperienceV1 } from '../types/webPublicExperience';

/**
 * Aplica la paleta configurada en el canal web del tenant (subdominio o ?tenant_id=).
 */
export function BookingAppearanceSync() {
  const { tenantId: subdomainTenantId, loading: tenantLoading } = useTenant();
  const [searchParams] = useSearchParams();
  const queryTenantId = searchParams.get('tenant_id');
  const { setBranding } = useWebBookingBranding();

  const effectiveTenantId =
    subdomainTenantId?.trim() || queryTenantId?.trim() || '';

  useEffect(() => {
    if (tenantLoading && !queryTenantId?.trim()) {
      return;
    }
    if (!effectiveTenantId) {
      applyBookingUiPreset('arena');
      resetWebChromeFromExperience();
      setBranding({
        tenantName: null,
        logoUrl: null,
        webPublicExperience: emptyWebPublicExperienceV1(),
        profileSlug: null,
      });
      return;
    }
    void fetchAndApplyBookingUiPreset(effectiveTenantId, setBranding);
  }, [effectiveTenantId, tenantLoading, queryTenantId, setBranding]);

  return null;
}
